import axios from 'axios'

const path = 'users'

export default {
  async login(username, password) {
    const resp = await axios.post(`${path}/login`, {
      username,
      password
    })

    return resp.data
  },

  async createUser(userDto) {
    await axios.post(`${path}`, userDto)
  },

  async updateUser(username, user) {
    await axios.put(`${path}/${username}`, user)
  },

  async resetPassword(username, req) {
    await axios.put(`${path}/${username}/password`, req)
  },

  async changeMyPassword(req) {
    await axios.put(`${path}/self/password`, req)
  },

  async deleteUser(username) {
    await axios.delete(`${path}/${username}`)
  },

  async getUser(username) {
    const resp = await axios.get(`${path}/${username}`)
    return resp.data
  },

  async getMyUser() {
    const resp = await axios.get(`${path}/self`)
    return resp.data
  },

  async listUsers(q, pageRequest) {
    const resp = await axios.get(`${path}`, {
      params: {
        q,
        ...pageRequest
      }
    })
    return resp.data
  }
}
